module.exports = __webpack_public_path__ + "public/SiteIcons/stripe-connect.png?3b9b6b86";